import { HttpErrorResponse } from "@angular/common/http";

interface IUserEditMessagesHelper {
  title: string;
  description: string;
  isEmailError: boolean;
}

export class UserEditMessagesHelper {
  private readonly DEFAULT_ERROR: IUserEditMessagesHelper = {
    title: "Não foi possível editar o usuário.",
    description:
      "Estamos trabalhando para resolver esse problema. Por favor, tente novamente mais tarde e, se o erro persistir, entre em contato com a nossa equipe de atendimento.",
    isEmailError: false,
  };

  public status = 0;
  public errorObj: { code: string; description: string };

  public descriptions: any = {
    0: {
      ...this.DEFAULT_ERROR,
    },
    403: {
      default: {
        ...this.DEFAULT_ERROR,
      },
      "32": {
        title: "Esse e-mail não pode ser utilizado.",
        description:
          "Esse e-mail é de domínio público e não pode ser utilizado nesse cadastro. Por favor, utilize seu e-mail corporativo.",
        isEmailError: true,
      },
    },
  };

  constructor(error: HttpErrorResponse) {
    this.status = error.status;
    this.errorObj = error?.error?.[0];
  }

  get error(): IUserEditMessagesHelper {
    const descriptionObj = this.descriptions[this.status];
    const code = this.errorObj?.code;
    return descriptionObj?.[code] ? descriptionObj[code] : this.DEFAULT_ERROR;
  }
}
